"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-arrow-drop-up-v2.tsx
var ArrowDropUpV2 = function ArrowDropUpV2(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 8 6",
    fill: "none",
    role: "img",
    "aria-hidden": "true",
    focusable: "false",
    strokeLinejoin: "round"
  }, props), (0, _preact.h)("path", {
    d: "M7 4.5L4 1.5L1 4.5",
    stroke: "currentColor",
    strokeWidth: "1.4",
    strokeLinecap: "round"
  }));
};

var _default = ArrowDropUpV2;
exports.default = _default;